import { CriteresExerciceDtoInput } from 'src/graphql/generated-types';

const stateName = '[Exercice] ';

export class GetExercicesGeneriqueListAction {
    static readonly type = stateName + 'getExercicesGeneriqueList';

    constructor(public criteres?: CriteresExerciceDtoInput) {
    }
}

export class GetListeExerciceInfosAction {
    static readonly type = stateName + 'getListeExerciceInfos';
}

export class GetListeExerciceBaseModelAction {
    static readonly type = stateName + 'GetListeExerciceBaseModel';
}

export class ExerciceStateResetAction {
    static readonly type = stateName + ' resetState';
}
